import axios from 'axios';
import Vue from 'vue';

/**
 * Misma base que el LMS (incluye /dev o /DEMO si aplica).
 * Ej. https://host/dev/api/public/pri + /scorm
 */
function apiBase() {
  try {
    const root = Vue.http && (Vue.http.options.root || Vue.http.options.url);
    if (root) {
      return String(root).replace(/\/+$/, '') + '/scorm';
    }
  } catch (e) {
    /* fallback abajo */
  }

  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'localhost' || host === '127.0.0.1') {
    return '/api/public/pri/scorm';
  }
  const path = (typeof window !== 'undefined' && window.location.pathname) || '';
  const prefixMatch = path.match(/^\/(dev|DEMO)(?=\/|$)/i);
  const prefix = prefixMatch ? '/' + prefixMatch[1] : '';
  return prefix + '/api/public/pri/scorm';
}

function authToken() {
  try {
    const raw = localStorage.getItem('apiKey_lms');
    if (!raw || raw === 'undefined') return '';
    return JSON.parse(raw);
  } catch (e) {
    return '';
  }
}

function http() {
  const token = authToken();
  const headers = { Accept: 'application/json' };
  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }
  return axios.create({
    baseURL: apiBase(),
    withCredentials: true,
    headers,
  });
}

export async function initializeAttempt({ courseId, scormPackageId, version }) {
  const { data } = await http().post('/runtime/initialize', {
    courseId: String(courseId),
    scormPackageId,
    version: version || '1.2',
  });
  return data;
}

export async function commitProgress(payload) {
  const { data } = await http().post('/runtime/commit', payload);
  return data;
}

export async function terminateAttempt(payload) {
  const { data } = await http().post('/runtime/terminate', payload);
  return data;
}

export async function fetchByTopic(cveTema) {
  const { data } = await http().get('/by-topic/' + encodeURIComponent(cveTema));
  return data;
}

export async function fetchProgress(cveTema) {
  const { data } = await http().get('/progress/' + encodeURIComponent(cveTema));
  return data;
}

export async function uploadPackage(formData) {
  const { data } = await http().post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function detectPackage(formData) {
  const { data } = await http().post('/detect', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export function buildRuntimePayload(courseId, scormPackageId, version, commitBody) {
  return {
    courseId: String(courseId),
    scormPackageId,
    version: version || '1.2',
    ...commitBody,
  };
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/services/scormApiClient.js